export const VALUES = {
  copilot: {
    displayName: 'Copilot',
  },
}
